// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_l3-0";
export var buttonContainer = "_l3-3";
export var cancelButton = "_l3-4";
export var headerSection = "_l3-6";
export var headerTitle = "_l3-9";
export var messageSideLeft = "_l3-1";
export var messageSideRight = "_l3-2";
export var orderNumberContainer = "_l3-7";
export var orderNumberLabel = "_l3-8";
export var submitButton = "_l3-5";